import { render, staticRenderFns } from "./OperationHistoryForm.vue?vue&type=template&id=bf5b7f70&"
import script from "./OperationHistoryForm.vue?vue&type=script&lang=ts&"
export * from "./OperationHistoryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports